import React from "react";
import { Link } from "react-router-dom";

import { Proposition } from "../shared/interfaces";

const PropLabel = ({ proposition }: { proposition: Proposition }) => (
    <div className="proposition__label">
      {proposition.contest && (
        <Link to={`/contest/${proposition.contest.slug}`}>
          {proposition.contest.name}
        </Link>
      )}
      {proposition.contest &&
        proposition.race &&
        proposition.contest.name !== proposition.race.name &&
        " / "}
      {proposition.race &&
        (!proposition.contest ||
          proposition.contest.name !== proposition.race.name) && (
          <span className="nobr">{proposition.race.name}</span>
        )}
    </div>
  );

export default PropLabel;
